import useGet from 'lib/hooks/useGet';
import { STATS_UPB_MATCH_PARTNER } from 'lib/networking/endpoints';

/**
 * useUpbMatchPartner — fetches a single partner's latest metric snapshot.
 *
 * Returns { data, loading, error, refetch }
 * data shape: { entity_id, name, cnd_id, match_pct, band, stats }
 */
function useUpbMatchPartner({ entityId, skip = false } = {}) {
  const url = entityId ? `${STATS_UPB_MATCH_PARTNER}/${entityId}` : STATS_UPB_MATCH_PARTNER;
  return useGet(url, {}, skip || !entityId);
}

export default useUpbMatchPartner;
